import React from "react";

import { Home as HomeStyled } from "./style";

export default function Home(_ref) {
  var children = _ref.children;

  return React.createElement(
    HomeStyled,
    null,
    children
  );
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Home/index.js
// module id = 142
// module chunks = 0